Cargo_ETDOccupyDays<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div slot="operations">
          <el-form inline :label-width="isZh?'80px':'145px'">
            <el-form-item :label="$t('CargoMsg.Cargo_Parter')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="cmpIdxMethodParams"
                callback-method-type="value"
                :default-value="searchForm.cmpIdx||''"
                :callback-params="{key:'cmpIdx'}"
                style="width: 220px"
                no="1"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessTypeP')">
              <el-select v-model="searchForm.busType" style="width: 220px" no="2" @change="busTypeChangeHandler">
                <el-option :label="$t('CargoMsg.Cargo_All')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Customer')" value="customer" />
                <el-option :label="$t('CargoMsg.Cargo_BookingAgent')" value="bookingAgent" />
                <el-option :label="$t('CargoMsg.Cargo_DestinationAgent')" value="overseaAgent" />
                <el-option :label="$t('CargoMsg.Cargo_NominatedAgent')" value="designationAgent" />
                <el-option :label="$t('CargoMsg.Cargo_LocalAgent')" value="localAgent" />
                <el-option :label="$t('CargoMsg.Cargo_CarrierShip')" value="seaCmp" />
                <el-option :label="$t('CargoMsg.Cargo_AirlineCompany')" value="airCmp" />
                <el-option :label="$t('CargoMsg.Cargo_CustomsBroker')" value="customsBroker" />
                <el-option :label="$t('CargoMsg.Cargo_TruckCompany')" value="truckCmp" />
                <el-option :label="$t('CargoMsg.Cargo_Warehouse')" value="warehouse" />
                <el-option :label="$t('CargoMsg.Cargo_GroupCompany')" value="global" />
                <el-option :label="$t('CargoMsg.Cargo_Shipper')" value="shipper" />
                <el-option :label="$t('CargoMsg.Cargo_Consignee')" value="consignee" />
                <el-option :label="$t('CargoMsg.Cargo_NotifyParty')" value="notify" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SalesP')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :method-params="{active:true, category:'role',shape:'sales'}"
                callback-method-type="value"
                :default-value="searchForm.sales||''"
                :callback-params="{key:'sales'}"
                style="width: 220px"
                no="3"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <br>
            <el-form-item :label="$t('CargoMsg.Cargo_PaymentPeriodRange')">
              <el-input-number v-model="searchForm.creditTermMin" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 80px" no="4" />
              <span style="margin: 0 2px">-</span>
              <el-input-number v-model="searchForm.creditTermMax" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 80px;margin-right: 2px" no="5" />
              <el-select v-model="searchForm.termUnit" style="width: 50px" no="6">
                <el-option :label="$t('CargoMsg.Cargo_Days')" value="0" />
                <el-option :label="$t('CargoMsg.Cargo_Week')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_Month')" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CreditLimitRange')">
              <el-input-number v-model="searchForm.creditMin" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 80px;" no="7" />
              <span style="margin: 0 2px">-</span>
              <el-input-number v-model="searchForm.creditMax" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 80px;margin-right: 2px" no="8" />
              <el-select v-model="searchForm.currency" style="width: 60px" no="9">
                <el-option :label="$t('CargoMsg.Cargo_All')" value="" />
                <el-option label="RMB" value="RMB" />
                <el-option label="USD" value="USD" />
              </el-select>
            </el-form-item>
            <br>
            <el-form-item :label="$t('CargoMsg.Cargo_SettlementType')">
              <el-select v-model="searchForm.settlementType" style="width: 220px" no="10">
                <el-option :label="$t('CargoMsg.Cargo_All')" value="0" />
                <el-option :label="$t('CargoMsg.Cargo_SettlementByBill')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_SettlementNotByBill')" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Blacklist')">
              <el-select v-model="searchForm.blacklist" style="width: 116px" no="11">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PaymentPeriodExceeded')">
              <el-select v-model="searchForm.dateExceeded" style="width: 116px" no="12">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CreditLimitExceeded')">
              <el-select v-model="searchForm.amountExceeded" style="width: 116px" no="13">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ETDExceeded')">
              <el-select v-model="searchForm.etdExceeded" style="width: 116px" no="22">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TempCredit')">
              <el-select v-model="searchForm.tempCredit" style="width: 116px" no="14">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WhetherIgnore')">
              <el-select v-model="searchForm.whetherIgnoreCharge" style="width: 116px" no="15">
                <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" value="" />
                <el-option :label="$t('CargoMsg.Cargo_Yes')" value="1" />
                <el-option :label="$t('CargoMsg.Cargo_No')" value="0" />
              </el-select>
            </el-form-item>
            <br>
            <el-form-item :label="$t('CargoMsg.Cargo_BranchCMPP')">
              <el-select v-model="searchForm.branchId" style="width: 220px" no="14">
                <el-option v-for="(item,index) in offices" :key="index" :label="(isZh?item.chineseName:item.englishName)||' '" :value="item.officeId" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" no="15" @click="searchHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
              <el-button v-if="!isZy && $checkPermission(['button_tabSettleAccountList_blacklist'])" type="primary" no="16" @click="onBlacklist">{{ blacklistLabel || $t('CargoMsg.Cargo_AddToBlackList') }}</el-button>
              <el-button type="primary" no="21" @click="onRefresh">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
              <el-button type="primary" no="23" @click="onRefreshCreditControl">刷新信控</el-button>
              <el-button type="primary" no="17" @click="resetClickHandler">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
              <span style="margin-left: 5px">{{ $t('CargoMsg.Cargo_HasChosen')+ ':' + currentCreditName }}</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            no="18"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            no="19"
            @pagination="toQuery()"
          />
        </div>
      </div>
      <credit-control-setting-dialog :visible.sync="creditControlSettingDialogVisible" :current-credit="currentCredit" :company="company" no="20" @handleSaved="handleSaved()" />
    </div>
  </div>
</template>

<script>
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as creditInfoApi from '@/api/partner/creditInfo'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { basicCacheKeys as cacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import CreditControlSettingDialog from '@/views/cargo/v0/Sales/components/creditControl/CreditControlSettingDialog'
import { repareNodeSort } from '@/utils/commonUtil'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroupHP'
import {
  CREDITDATETYPE_DAY2,
  CREDITDATETYPE_HALFMONTH,
  CREDITDATETYPE_MONTH,
  CREDITDATETYPE_MONTH2, CREDITDATETYPE_WEEK,
  DATETYPE_TYPE
} from '@/class/cargo/model/parameters/ContractConstants'
import i18n from '@/lang'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'TabCreditControl',
  components: { CargoAdvanceSelect, CreditControlSettingDialog },
  data() {
    return {
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: (params) => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('Sales.CurrentlySelected'),
              action: function() {
                self.handleExportSelectedToExcel(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('Sales.CurrentPage'),
              action: function() {
                self.handleCurPageExportToExcel(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('Sales.CurrentlySelected'),
              action: function() {
                self.handleExportSelectedToPdf(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('Sales.CurrentPage'),
              action: function() {
                self.handleCurPageExportToPdf(params)
              }
            }
          ]
        },
        onRowClicked: this.onSelect,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        // CARGO-34394，为了实现选中导出，添加复选框显示列
        { headerName: '', headerCheckboxSelection: true, checkboxSelection: true, width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false },
        { headerName: this.$t('CargoMsg.Cargo_Abbreviation'), field: 'shortName', width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_ChineseName'), field: 'chineseName', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_EnglishName'), field: 'englishName', width: 100, hide: true },
        { headerName: this.$t('CargoMsg.Cargo_Tel'), field: 'tel', width: 100, hide: true },
        { headerName: this.$t('SeaExport.Address'), field: 'address', width: 100, hide: true },
        { headerName: this.$t('CargoMsg.Cargo_BranchCompany'), field: 'branchId', width: 100, hide: true,
          cellRenderer: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
        },
        { headerName: this.$t('CargoMsg.Cargo_isActive'), field: 'active', width: 100, hide: true,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_GroupCompany'), field: 'isGlobal', width: 100, hide: true,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_Blacklist'), field: 'creditInfoIsBlacklist', width: 100,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementMethod'), field: 'creditInfoCreditMethod', width: 100,
          cellRenderer: params => this.creditDateTypeLabel(params.data),
          filterParams: {},
          filterValueGetter: (params) => {
            return this.creditDateTypeLabel(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'creditInfoCreditDateType', width: 100,
          cellRenderer: params => this.settlementTypeLabFun(params.data),
          filterParams: {},
          filterValueGetter: (params) => {
            return this.settlementTypeLabFun(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DateType'), field: 'creditInfoRemarks', width: 100,
          cellRenderer: params => this.dateTypeLabel(params.data),
          filterParams: {},
          filterValueGetter: params => this.dateTypeLabel(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'creditInfoCreditDateLimited', width: 100,
          cellRenderer: params => this.creditTermLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.creditTermLabelFunc(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_Limit'), field: 'creditInfo.credit', width: 100,
          cellRenderer: params => this.creditLimitLabelFunc(params.data, 'credit'),
          filterParams: {},
          filterValueGetter: params => this.creditLimitLabelFunc(params.data, 'credit')
        },
        { headerName: this.$t('CargoMsg.Cargo_QuotaCurrency'), field: 'creditInfo.currency', width: 100,
          cellRenderer: params => this.creditLimitLabelFunc(params.data, 'currency'),
          filterParams: {},
          filterValueGetter: params => this.creditLimitLabelFunc(params.data, 'currency')
        },
        { headerName: this.$t('CargoMsg.Cargo_UsedQuota'), field: 'usedAmount', width: 100,
          cellRenderer: params => this.creditUsedLabelFunc(params.data, 'usedAmount'),
          filterParams: {},
          filterValueGetter: params => this.creditUsedLabelFunc(params.data, 'usedAmount')
        },
        { headerName: this.$t('CargoMsg.Cargo_CreditUsed'), field: 'arAmount', width: 100, hide: true,
          cellRenderer: params => this.creditUsedLabelFunc(params.data, 'arAmount'),
          filterParams: {},
          filterValueGetter: params => this.creditUsedLabelFunc(params.data, 'arAmount')
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentPeriodExceeded'), field: 'creditInfoDateExceeded', width: 100,
          cellRenderer: params => this.creditInfoDateExceededLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.creditInfoDateExceededLabelFunc(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_WhetherIgnore'), field: 'whetherIgnoreCharge', width: 100,
          cellRenderer: params => ColumnUtils.booleanLabelFunction(params.data.whetherIgnoreCharge),
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.data.whetherIgnoreCharge)
        },
        { headerName: this.$t('CargoMsg.Cargo_CreditLimitExceeded'), field: 'creditInfoAmountExceeded', width: 100,
          cellRenderer: params => this.creditInfoAmountExceededLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.creditInfoAmountExceededLabelFunc(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_ETDSettingDays'), field: 'etdDays', width: 110
        },
        { headerName: this.$t('CargoMsg.Cargo_ETDOccupyDays'), field: 'etdOccupyDays', width: 110
        },
        { headerName: this.$t('CargoMsg.Cargo_ETDExceeded'), field: 'etdExceeded', width: 100,
          cellRenderer: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_OverdueLimit'), field: 'overdueAmount', width: 100, hide: true,
          cellRenderer: params => this.overdueAmountLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.overdueAmountLabelFunc(params.data)
        },
        { headerName: this.$t('CargoMsg.Cargo_TempCredit'), field: 'tempCreditEffect', width: 100,
          cellRenderer: params => this.tempCreditEffectLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => this.tempCreditEffectLabelFunc(params.data)
        },
        { headerName: this.$t('AdvancePayment.BlacklistRemark'), field: 'blacklistRemark', initialWidth: 260, minWidth: 260, hide: true },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          hide: true,
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      searchForm: {
        cmpIdx: '',
        busType: '',
        sales: '',
        creditTermMin: 0,
        creditTermMax: 0,
        termUnit: '0',
        creditMin: 0,
        creditMax: 0,
        currency: '',
        settlementType: '0',
        blacklist: '',
        dateExceeded: '',
        amountExceeded: '',
        etdExceeded: '',
        tempCredit: '',
        branchId: '',
        whetherIgnoreCharge: ''
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 30
      },
      blacklistLabel: '',
      currentCreditName: '',
      cmpIdxMethodParams: { active: true },
      offices: [],
      priEdit: true,
      priOperate: true,
      company: {},
      currentCredit: {},
      isZy: false, // 是否中邮
      creditControlSettingDialogVisible: false
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  async created() {
    this.initOffices()
    await cache.load(cacheName.CONFIG)
    this.isZy = String(cache.config.get('ToExoSystem')) === 'zy'
  },
  methods: {
    onSelect(event) {
      if (event.data) {
        const company = event.data
        this.company = company
        this.currentCredit = company.creditInfo
        this.currentCreditName = company.chineseName
        if (this.currentCredit.blacklist) {
          this.blacklistLabel = this.$t('CargoMsg.Cargo_RemoveToBlackList')
        } else {
          this.blacklistLabel = this.$t('CargoMsg.Cargo_AddToBlackList')
        }
      }
    },
    // 查询
    toQuery() {
      const filter = this.conditions
      filter.pageSize = this.filter.pageSize > 0 ? this.filter.pageSize : 30
      filter.pageNum = this.filter.pageNum > 0 ? this.filter.pageNum : 1
      const loading = getLoading()
      creditInfoApi.searchCompanyForCreditPermit(filter).then(resp => {
        this.querySuccessHandler(resp)
      }).finally(() => loading.close())
    },
    handleSaved() {
      this.searchHandler()
    },
    querySuccessHandler(resp) {
      const data = resp.data
      if (data) {
        this.filter.total = Number(data.total)
        this.filter.pageNum = data.pageNum
        this.rowData = resp.data.list
      }
    },
    creditTermLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          const info = contract
          if (info.termUnit === 0) {
            text = text + (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Days')
          }

          if (info.termUnit === 1) {
            text = text + (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Week')
          }

          if (info.termUnit === 2) {
            text = text + (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Month')
          }

          text = text + '/'
        })
        return text.slice(0, -1)
      }
      const info = company.creditInfo
      if (!info) return ''
      if (info.termUnit === 0) {
        return (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Days')
      }

      if (info.termUnit === 1) {
        return (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Week')
      }

      if (info.termUnit === 2) {
        return (info.creditDateLimited ? info.creditDateLimited : 0) + this.$t('CargoMsg.Cargo_Month')
      }

      return (info.creditDateLimited ? info.creditDateLimited : 0)
    },
    // creditLimitLabelFunc(company) {
    //   if (company.normalRuleContactExist) {
    //     let text = ''
    //     company.contractList.forEach(contract => {
    //       const info = contract
    //       text = text + (info.currency ? info.currency : '') + (info.credit ? info.credit : '0.')
    //       text = text + '/'
    //     })
    //     return text.slice(0, -1)
    //   }
    //   const info = company.creditInfo
    //   if (!info) return ''
    //   return (info.currency ? info.currency : '') + (info.credit ? info.credit : '0.')
    // },
    creditLimitLabelFunc(company, value) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          const info = contract
          text = text + (info[value] ? info[value] : '0.')
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      const info = company.creditInfo
      if (!info) return ''
      return (info[value] ? info[value] : '0.')
    },
    creditUsedLabelFunc(company, data) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          text = text + ColumnUtils.number2ColumnLabelFunc(contract[data])
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      return ColumnUtils.number2ColumnLabelFunc(company.creditInfo[data])
    },
    creditInfoDateExceededLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          text = text + ColumnUtils.booleanLabelFunction(contract.dateExceeded)
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      return ColumnUtils.booleanLabelFunction(company.creditInfo.dateExceeded)
    },
    creditInfoAmountExceededLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          text = text + ColumnUtils.booleanLabelFunction(contract.amountExceeded)
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      return ColumnUtils.booleanLabelFunction(company.creditInfo.amountExceeded)
    },
    tempCreditEffectLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          text = text + ColumnUtils.booleanLabelFunction(contract.tempCreditEffect)
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      return ColumnUtils.booleanLabelFunction(company.tempCreditEffect)
    },
    overdueAmountLabelFunc(company) {
      if (company.normalRuleContactExist) {
        const text = []
        company.contractList.forEach(contract => {
          if (contract.overdueAmount) {
            text.push(contract.overdueAmount)
          } else {
            text.push(0)
          }
        })
        return text.join('/')
      }
      return company.overdueAmount
    },
    // 结算类型
    settlementTypeLabFun(company) {
      if (company == null) return ''
      if (company.normalRuleContactExist) {
        return ColumnUtils.settlementTypeLabFun(company)
      }
      const info = company.creditInfo
      if (info['creditDateLimited'] === 0 && [CREDITDATETYPE_MONTH2.code, CREDITDATETYPE_MONTH.code, CREDITDATETYPE_WEEK.code, CREDITDATETYPE_HALFMONTH.code, CREDITDATETYPE_DAY2.code].indexOf(info['creditDateType']) !== -1) {
        return this.$t('Message.ByTicket')
      } else {
        return this.$t('Partners.settlementNotByBill')
      }
    },
    creditDateTypeLabel(company) {
      if (company == null) return ''
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          const value = contract.creditDateType
          if (value === -1 || value === 0) {
            text = text + this.$t('CargoMsg.Cargo_Monthly')
          } else if (value === -2) {
            text = text + this.$t('CargoMsg.Cargo_WeekSettlement')
          } else if (value === -3) {
            text = text + this.$t('CargoMsg.Cargo_HalfMonthly')
          } else if (value === -4) {
            text = text + this.$t('CargoMsg.Cargo_DailySettlement')
          } else if (value > 0) {
            text = text + this.$t('CargoMsg.Cargo_EveryMonth') + value + this.$t('CargoMsg.Cargo_Day')
          }
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      const value = company.creditInfo.creditDateType
      if (value === -1 || value === 0) {
        return this.$t('CargoMsg.Cargo_Monthly')
      } else if (value === -2) {
        return this.$t('CargoMsg.Cargo_WeekSettlement')
      } else if (value === -3) {
        return this.$t('CargoMsg.Cargo_HalfMonthly')
      } else if (value === -4) {
        return this.$t('CargoMsg.Cargo_DailySettlement')
      } else if (value > 0) {
        return this.$t('CargoMsg.Cargo_EveryMonth') + value + this.$t('CargoMsg.Cargo_Day')
      }
      return ''
    },
    // 右击菜单列表-导出Excel(当前选择)
    handleExportSelectedToExcel(params) {
      const { api, columnApi } = params
      // 获取显示列
      const allDisplayedColumns = columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rowsToDisplay = []
      api.forEachNode(node => {
        if (node.selected) {
          rowsToDisplay.push(node)
        }
      })
      repareNodeSort(rowsToDisplay)
      const rows = rowsToDisplay.map(item => item.data)
      if (rows.length === 0) {
        this.$message.error(this.$t('Message.NoDataIsCurrentlySelected'))
        return
      }
      this.loading = getLoading()
      setTimeout(() => {
        const fileName = this.getFileName()
        const { totalConfig } = this
        if (totalConfig) {
          totalConfig.forEach(item => {
            item.dataProvider = rows
            const charge = new ChargeCurrencyTotalGroup(item)
            charge.recalc()
          })
        }
        exportExcel(fileName, rows, allDisplayedColumns, true, totalConfig)
        this.loading.close()
      }, 100)
    },
    // 右击菜单列表-导出Excel(当前页)
    handleCurPageExportToExcel(params) {
      this.loading = getLoading()
      setTimeout(() => {
        const { api, columnApi } = params
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        // 获取当前显示行
        const rowsToDisplay = []
        api.forEachNode(node => {
          if (node.displayed) {
            rowsToDisplay.push(node)
          }
        })
        repareNodeSort(rowsToDisplay)
        const rows = rowsToDisplay.map(item => item.data)
        console.log('excel', rows)
        const fileName = this.getFileName()
        const { totalConfig } = this
        if (totalConfig) {
          totalConfig.forEach(item => {
            item.dataProvider = rows
            const charge = new ChargeCurrencyTotalGroup(item)
            charge.recalc()
          })
        }
        exportExcel(fileName, rows, allDisplayedColumns, true, totalConfig)
        this.loading.close()
      }, 100)
    },
    // 右击菜单列表-导出PDF(当前选择)
    handleExportSelectedToPdf(params) {
      const { api, columnApi } = params
      // 获取显示列
      const allDisplayedColumns = columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rowsToDisplay = []
      api.forEachNode(node => {
        if (node.selected) {
          rowsToDisplay.push(node)
        }
      })
      repareNodeSort(rowsToDisplay)
      const rows = rowsToDisplay.map(item => item.data)
      if (rows.length === 0) {
        this.$message.error(this.$t('Message.NoDataIsCurrentlySelected'))
        return
      }
      this.loading = getLoading()
      setTimeout(() => {
        const fileName = this.getFileName()
        exportPdf(fileName, rows, allDisplayedColumns)
        this.loading.close()
      }, 100)
    },
    getFileName() {
      const date = new Date()
      const month = date.getMonth() + 1
      const hour = date.getHours()
      const min = date.getMinutes()
      const sec = date.getSeconds()
      return this.exportFileName || `R${month}${hour}${min}${sec}`
    },
    // 右击菜单列表-导出PDF(当前页)
    handleCurPageExportToPdf(params) {
      this.loading = getLoading()
      setTimeout(() => {
        const { api, columnApi } = params
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        const fileName = this.getFileName()
        // 获取当前显示行
        const rowsToDisplay = []
        api.forEachNode(node => {
          if (node.displayed) {
            rowsToDisplay.push(node)
          }
        })
        repareNodeSort(rowsToDisplay)
        const rows = rowsToDisplay.map(item => item.data)
        exportPdf(fileName, rows, allDisplayedColumns)
        this.loading.close()
      }, 100)
    },
    getValueFromChild(obj) {
      this.searchForm[obj.key] = obj.value
    },
    /**
     * 按业务类型过滤客户(不用做后台查询)
     */
    busTypeChangeHandler() {
      if (this.searchForm.busType !== '') {
        this.cmpIdxMethodParams = { active: true }
        this.cmpIdxMethodParams[this.searchForm.busType] = true
      } else {
        this.cmpIdxMethodParams = { active: true }
      }
    },
    initOffices() {
      const offices = [{ chineseName: this.$t('CargoMsg.Cargo_All'), officeId: 0 }]
      const allCacheOffices = getCacheListByKey(cacheKeys.basic_data_Office_All)
      for (const office of allCacheOffices) {
        const item = {}
        item.chineseName = office.chineseName
        item.englishName = office.englishName
        item.officeId = office.officeId
        offices.push(item)
      }
      this.offices = offices
      for (const item of offices) {
        if (item.officeId === this.$store.getters.currentOfficeId) {
          this.searchForm.branchId = this.$store.getters.currentOfficeId
          break
        }
      }
    },
    resetClickHandler() {
      const initForm = {
        cmpIdx: '',
        busType: '',
        sales: '',
        creditTermMin: 0,
        creditTermMax: 0,
        termUnit: '0',
        creditMin: 0,
        creditMax: 0,
        currency: '',
        settlementType: '0',
        blacklist: '',
        dateExceeded: '',
        amountExceeded: '',
        etdExceeded: '',
        tempCredit: '',
        whetherIgnoreCharge: ''
      }
      this.busTypeChangeHandler()
      Object.assign(this.searchForm, initForm)
    },
    getCondition() {
      const item = {}
      // 合作伙伴
      if (this.searchForm.cmpIdx > 0) {
        item.cmpIdx = this.searchForm.cmpIdx
      }
      // 账期类型
      if (Number(this.searchForm.settlementType) > 0) {
        item.settlementType = Number(this.searchForm.settlementType)
      }
      // 销售
      if (Number(this.searchForm.sales) > 0) {
        item.sales = Number(this.searchForm.sales)
      }
      // 账期范围
      if (this.searchForm.creditTermMin > 0) {
        item.creditTermMin = this.searchForm.creditTermMin
      }
      if (this.searchForm.creditTermMax > 0) {
        item.creditTermMax = this.searchForm.creditTermMax
      }
      if (item.hasOwnProperty('creditTermMin') || item.hasOwnProperty('creditTermMax')) {
        item.termUnit = Number(this.searchForm.termUnit)
      }
      // 额度范围
      if (this.searchForm.creditMin > 0) {
        item.creditMin = this.searchForm.creditMin
      }
      if (this.searchForm.creditMax > 0) {
        item.creditMax = this.searchForm.creditMax
      }
      if (this.searchForm.currency) {
        item.currency = this.searchForm.currency
      }
      // 黑名单
      if (this.searchForm.blacklist !== '') {
        item.blacklist = Number(this.searchForm.blacklist)
      }
      // 账期超出
      if (this.searchForm.dateExceeded !== '') {
        item.dateExceeded = Number(this.searchForm.dateExceeded)
      }
      // 额度超出
      if (this.searchForm.amountExceeded !== '') {
        item.amountExceeded = Number(this.searchForm.amountExceeded)
      }
      // ETD 超出
      if (this.searchForm.etdExceeded !== '') {
        item.etdExceeded = Number(this.searchForm.etdExceeded)
      }
      // 临时信控
      if (this.searchForm.tempCredit !== '') {
        item.tempCredit = Number(this.searchForm.tempCredit)
      }
      // 是否忽略
      if (this.searchForm.whetherIgnoreCharge !== '') {
        item.whetherIgnoreCharge = Number(this.searchForm.whetherIgnoreCharge)
      }
      // 分公司选项
      if (this.searchForm.branchId != null && this.searchForm.branchId > 0) {
        item.branchId = this.$store.getters.currentOfficeId
      }
      // 业务类型
      if (this.searchForm.busType) {
        item.companyType = this.searchForm.busType
      }
      return item
    },
    // 查询
    searchHandler() {
      if (this.$checkPermission(['button_SMCreditControl_manage'])) {
        this.priEdit = true
      }
      let lob = ''
      if (this.$checkPermission(['button_SMCreditControl_permitAE'])) {
        lob += '\'AE\','
      }
      if (this.$checkPermission(['button_SMCreditControl_permitAI'])) {
        lob += '\'AI\','
      }
      if (this.$checkPermission(['button_SMCreditControl_permitSE'])) {
        lob += '\'SE\','
      }
      if (this.$checkPermission(['button_SMCreditControl_permitSI'])) {
        lob += '\'SI\','
      }
      if (lob.length > 0) {
        lob = lob.substr(0, lob.length - 1)
        this.priOperate = true
      } else {
        this.priOperate = false
      }
      const item = this.getCondition()
      item.pageNum = this.filter.pageNum
      item.pageSize = this.filter.pageSize
      if (this.priEdit) {
        const loading = getLoading()
        creditInfoApi.searchCompanyForCreditControlNew(item).then(resp => {
          if (resp.code === '0') {
            this.success(resp)
          } else {
            this.fail(resp)
          }
        }).finally(() => loading.close())
      } else if (this.priOperate) {
        item.lob = lob
        creditInfoApi.searchCompanyForCreditPermit(item).then(resp => {
          if (resp.code === '0') {
            this.success(resp)
          } else {
            this.fail(resp)
          }
        })
      }
    },
    success(resp) {
      const o = resp.data
      if (o != null && o.list != null) {
        const companies = o.list.list
        const cMap = o.cMap
        for (const company of companies) {
          if (!company.creditInfo) {
            company.creditInfo = {}
            company.creditInfo.company = company
          }
          if (cMap != null) {
            company.overdueAmount = cMap[company.uuid]
          }
          company.creditInfoIsBlacklist = company.creditInfo.blacklist
          company.creditInfoCreditDateType = company.creditInfo.creditDateType
          company.creditInfoCreditMethod = company.creditInfo.creditDateType
          company.creditInfoRemarks = company.creditInfo.remarks
          company.creditInfoDateExceeded = company.creditInfo.dateExceeded
          company.creditInfoAmountExceeded = company.creditInfo.amountExceeded
          company.usedAmount = company.creditInfo.usedAmount
          company.blacklistRemark = company.creditInfo.blacklistRemark
        }
        this.filter.total = Number(o.list.total)
        this.filter.pageNum = o.list.pageNum
        this.filter.pageSize = o.list.pageSize
        this.rowData = companies
      }
    },
    fail(resp) {
      const m = resp.data
      this.$message.error(m.faultCode + ' ' + m.faultString)
    },
    // 加入黑名单
    onBlacklist() {
      let title = ''
      if (this.blacklistLabel === this.$t('CargoMsg.Cargo_RemoveToBlackList')) {
        title = this.$t('CargoMsg.Cargo_SureToRemoveToBlackList')
      }
      if (this.blacklistLabel === this.$t('CargoMsg.Cargo_AddToBlackList')) {
        title = this.$t('CargoMsg.Cargo_SureToAddToBlackList')
      }
      this.$confirm(title, this.$t('CargoMsg.Cargo_Tips')).then(() => {
        const cell = this.gridOptions.api.getFocusedCell()
        const nodes = this.gridOptions.api.rowModel.rowsToDisplay
        const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
        if (node && node.data) {
          this.currentCredit = node.data.creditInfo
        }
        if (this.currentCredit == null) {
          this.$message.warning(this.$t('Sales.PleaseSelectAPartner'))
          return
        }
        this.currentCredit.blacklist = !this.currentCredit.blacklist
        this.blacklistLabel = this.currentCredit.blacklist ? this.$t('CargoMsg.Cargo_RemoveToBlackList') : this.$t('CargoMsg.Cargo_AddToBlackList')
        const loading = getLoading()
        creditInfoApi.saveCreditInfo(this.currentCredit).then(resp => {
          this.searchHandler()
        }).finally(() => loading.close())
      })
    },
    // 刷新
    onRefresh() {
      if (!this.company || !this.company.cmpIdx || !this.currentCredit || !this.currentCredit.uuid) {
        this.$message.warning(this.$t('Sales.PleaseSelectAPartner'))
        return
      }
      const loading = getLoading()
      creditInfoApi.creditCheck({ accountId: this.company.cmpIdx, creditInfoUuid: this.currentCredit.uuid }).then(resp => {
        if (resp.code === '0') {
          this.searchHandler()
        } else if (resp.data && (resp.data.faultCode || resp.data.faultString)) {
          this.$message.error((resp.data.faultCode || '') + ' ' + (resp.data.faultString || ''))
        } else {
          this.$message.error(resp.message || this.$t('CargoMsg.Cargo_RefreshData'))
        }
      }).finally(() => loading.close())
    },
    // 刷新信控
    onRefreshCreditControl() {
      if (!this.company || !this.company.cmpIdx || !this.currentCredit || !this.currentCredit.uuid) {
        this.$message.warning(this.$t('Sales.PleaseSelectAPartner'))
        return
      }
      const params = { accountId: this.company.cmpIdx, creditInfoUuid: this.currentCredit.uuid }
      const jobUuid = this.$route && this.$route.query ? this.$route.query.jobUuid : ''
      if (jobUuid) params.jobUuid = jobUuid
      const loading = getLoading()
      creditInfoApi.creditCheck(params).then(resp => {
        if (resp.code === '0') {
          this.searchHandler()
        } else if (resp.data && (resp.data.faultCode || resp.data.faultString)) {
          this.$message.error((resp.data.faultCode || '') + ' ' + (resp.data.faultString || ''))
        } else {
          this.$message.error(resp.message || this.$t('CargoMsg.Cargo_RefreshData'))
        }
      }).finally(() => loading.close())
    },
    onRowDoubleClicked(event) {
      this.onSelect(event)
      this.creditControlSettingDialogVisible = true
    },
    dateTypeLabel(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          text = text + ColumnUtils.columnLabelFunc(DATETYPE_TYPE, contract.dateType)
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      return ColumnUtils.columnLabelFunc(DATETYPE_TYPE, company.creditInfo.remarks)
    }
  }
}
</script>

<style scoped>

</style>
